"use strict";
/**
 * @author jdiaz5513
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var debug_1 = require("debug");
var list_element_size_1 = require("../list-element-size");
var list_1 = require("./list");
var pointer_1 = require("./pointer");
var trace = debug_1.default("capnp:list:composite");
trace("load");
var Uint8List = /** @class */ (function (_super) {
    tslib_1.__extends(Uint8List, _super);
    function Uint8List() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Uint8List.prototype.get = function (index) {
        var c = pointer_1.getContent(this);
        return c.segment.getUint8(c.byteOffset + index);
    };
    Uint8List.prototype.set = function (index, value) {
        var c = pointer_1.getContent(this);
        c.segment.setUint8(c.byteOffset + index, value);
    };
    Uint8List.prototype.toString = function () {
        return "Uint8_" + _super.prototype.toString.call(this);
    };
    Uint8List._capnp = {
        displayName: "List<Uint8>",
        size: list_element_size_1.ListElementSize.BYTE
    };
    return Uint8List;
}(list_1.List));
exports.Uint8List = Uint8List;

//# sourceMappingURL=uint8-list.js.map
